module.exports = __webpack_public_path__ + "static/media/parawebcv_page-0008.0167c3b1.jpg";